import axios from "axios";
import {openEndpoint} from '../util/endpoint';
const getNewsService = (query)=>{
  return  axios.get(openEndpoint.getNews+'?per_page=10&offset='+query)
}
export{
    getNewsService  
}